export function downloadFile(authToken: string, url: string) {
    return window.fetch(url, {
        headers: new Headers({
            Authorization: 'Bearer ' + authToken,
        }),
    });
}
